import script from "./pay.vue?vue&type=script&setup=true&lang=ts"
export * from "./pay.vue?vue&type=script&setup=true&lang=ts"

import "./pay.vue?vue&type=style&index=0&id=e784c172&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e784c172"]])

export default __exports__